module.exports = __webpack_public_path__ + "static/media/anatomia.d6250bf7.png";